module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"actions":"Actions"},"de":{"actions":"Aktionen"}}')
  delete Component.options._Ctor
}
